export enum MediaTypes {
    PHONE = 'phone',
    TABLET = 'tablet',
    DESKTOP_SMALL = 'desktopSmall',
    DESKTOP_MEDIUM = 'desktopMedium',
}

export interface MediaState {
    isMobile: boolean;
    isPhone: boolean;
    isTablet: boolean;
    isDesktop: boolean;
    isDesktopSmall: boolean;
    isDesktopMedium: boolean;
    windowWidth: number;
}

export interface IActionType {
    type: MediaTypes;
    windowWidth: number;
}
